import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'

import { useTRPC } from '@/trpc'
import { useAuth } from '@/auth/AuthContext'
import EditUserForm from '@/users/EditUserForm'

import $form from '@tandem/ui/form.css'
import $type from '@tandem/ui/type.css'
import $card from '@tandem/ui/card.css'
import clsx from 'clsx'
import { useToast } from '@tandem/ui/Toast'
import $ from './-styles.css'

export const Route = createFileRoute('/settings/')({
  component: SettingsPage,
})

function SettingsPage() {
  let trpc = useTRPC()
  let { user: authUser } = useAuth()

  let toast = useToast()

  let userQuery = useQuery(trpc.user.get.queryOptions(authUser?.id ?? 0, {
    enabled: !!authUser?.id,
  }))

  let user = userQuery.data

  if (!authUser || !user) {
    return <div>Загрузка...</div>
  }

  return (
    <div class={clsx('container', $.container)}>
      <h2>Настройки</h2>
      <div class={$card.rect}>
        <EditUserForm user={user} />
      </div>
    </div>
  )
}
